// extracted by mini-css-extract-plugin
export default {"wrapper":"alert-banner-list-module--wrapper--13da9"};